import * as React from "react"
export const Svg_016 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={60}
    height={58}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M30 31.752c2.553 0 4.623-2.001 4.623-4.469 0-2.468-2.07-4.469-4.623-4.469-2.553 0-4.623 2.001-4.623 4.469 0 2.468 2.07 4.469 4.623 4.469Z"
    />
    <path
      fill="url(#b)"
      d="M49.453 13.14H10.547v28.285h38.906V13.142Zm-8.339 15.842h-3.167c-.68 2.977-3.11 5.325-6.19 5.983v3.062h-3.515v-3.062c-3.079-.658-5.509-3.006-6.19-5.983h-3.166v-3.398h3.167c.68-2.977 3.11-5.325 6.19-5.983v-3.062h3.515v3.062c3.079.658 5.509 3.006 6.19 5.983h3.166v3.398Z"
    />
    <path fill="url(#c)" d="M0 19.938h7.031v14.69H0v-14.69Z" />
    <path
      fill="url(#d)"
      d="M0 2.945V16.54h7.031V9.742H52.97v35.082H7.03v-6.797H0v13.594h7.031v3.434h3.516V51.62h38.906v3.434h3.516V51.62H60V2.945H0Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={27.515}
        x2={31.695}
        y1={24.155}
        y2={31.152}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={19.544}
        x2={30.774}
        y1={17.383}
        y2={42.384}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={1.626}
        x2={9.181}
        y1={22.141}
        y2={27.993}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={13.875}
        x2={36.938}
        y1={10.762}
        y2={53.739}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)